import Banner from '../banner/Banner';
import Input from '../input/Input';
import inputTypes from '../login/inputTypes';
import PagePath from '../pagePath/PagePath';
import styles from './contact.module.css';

const Contact = () => {
    const filteredInputTypes = inputTypes.filter((ele) => ele.page === 'contact');
    return (
        <section className={styles.contact}>
            <Banner imgSrc="Contact-us-.jpg" />
            <div className='pageContainer'>
                <PagePath categoryName="Contact Us" />
                <form className={styles.contactForm}>
                    <div className={styles.contactFormInputs}>
                        {filteredInputTypes.map((obj, index) => {
                            return (
                                <Input
                                    key={obj.id}
                                    inputType={obj.inputType}
                                    placeholder={obj.placeholder}
                                    id={obj.inputId}
                                    ifRequired={obj.ifRequired}
                                    labelTitle={obj.labelTitle}
                                />
                            )
                        })}
                    </div>
                    <div className={styles.contactFormCheck}>
                        <div className={styles.contactFormMessage}>
                            <Input
                                isTxtArea={true}
                                inputType={'text'}
                                placeholder={'Enter Your Message'}
                                id={'message'}
                                ifRequired={true}
                                labelTitle={'Message'}
                            />
                        </div>
                        <div className={styles.contactFormCheckCont}>
                            <div className={styles.captchaHolder}>
                                <img src={process.env.PUBLIC_URL + `/assets/imgs/default.png`} alt="captcha" />
                                <button className={styles.contactFormcaptchaReset} type='submit'>Reset</button>
                            </div>
                            <Input
                                inputType={'text'}
                                placeholder={''}
                                id={''}
                                ifRequired={false}
                                labelTitle={''}
                            />
                        </div>
                    </div>
                    <button className={styles.contactFormSend} type='submit'>Send</button>
                </form>
            </div>
        </section>
    )
}

export default Contact;
